<template>
  <v-card :loading="loading">
    <v-card-title class="subtitle-2">
      FPS chart
    </v-card-title>
    <v-card-text v-if="!show || loading" height="350" class="pa-2 caption black--text">
      <v-sheet height="350" class="d-flex justify-center align-center">
        <v-btn
          color="primary"
          :loading="loading"
          @click="show = true"
        >
          Load data
        </v-btn>
      </v-sheet>
    </v-card-text>
    <v-card-text v-else class="pa-2 caption black--text">
      <v-select
        v-model="currentCategory"
        :items="categories"
        outlined
        dense
      />
      <apexchart
        :key="currentCategory"
        type="boxPlot"
        :height="height"
        :options="chartOptions"
        :series="[{
          name: this.currentCategory,
          data: this.seriesData
        }]"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import helper from '../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  data () {
    return {
      loading: false,
      info: [],
      show: false,
      currentCategory: 'FPS',
      categories: [
        "FPS",
        "FrameMinFPS",
        "FrameMaxFPS",
        "FrameTime",
        "GameThreadTime",
        "RenderThreadTime",
        "RHITTime",
        "GPUFrameTime"
      ],
      chartOptions: {
        chart: {
          type: 'boxPlot'
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        yaxis: {
          labels: {
            maxWidth: 300
          }
        },
        xaxis: {
          title: {
            text: 'FPS'
          },
        },
        annotations: {
          xaxis: [
            {
              x: 30,
              borderColor: '#FF9800',
              strokeDashArray: 0,
              label: {
                borderColor: '#FF9800',
                style: {
                  color: '#fff',
                  background: '#FF9800',
                },
                text: '30 fps',
              },
            },
            {
              x: 60,
              borderColor: '#E91E63',
              strokeDashArray: 0,
              label: {
                borderColor: '#E91E63',
                style: {
                  color: '#fff',
                  background: '#E91E63',
                },
                text: '60 fps',
              },
            },
          ]
        }
      }
    }
  },
  watch: {
    async '$route.params' () {
      if (this.show) {
        await this.getData()
      }
    },
    async show (val) {
      if (val) {
        await this.getData()
      }
    }
  },
  computed: {
    seriesData () {
      return this.info.map(val => ({
        x: `${val.count} - ${val.name}`,
        y: val[this.currentCategory],
        count: val.count
      })).sort((a, b) => b.count - a.count)
    },
    height () {
      return Math.max(150 + this.info.length * 20, 300)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/marketing/telemetry/fps`, {
          params: {
            build_tag: this.$route.params.buildTag
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.info = data
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
  .align-top {
    vertical-align: top;
  }
</style>